import classNames from 'classnames';
import './Page.scss';

export type PageProps = JSX.IntrinsicElements['div'];

export const Page = ({ className, ...props }: PageProps) => (
  <div className={classNames('page', className)} {...props} />
);
